import { useFindOneContactSentimentQuery } from 'services';
import { FindOneContactSentimentDto } from 'types';

export const useFindOneContactSentiment = (data?: FindOneContactSentimentDto, options?: any) => {
  const {
    data: contactSentiment,
    isLoading: isLoadingContactSentiment,
    isFetching: isFetchingContactSentiment,
    refetch: refetchContactSentiment
  } = useFindOneContactSentimentQuery(data!, {
    refetchOnMountOrArgChange: true,
    skip: !data,
    ...options
  });

  return {
    contactSentiment: contactSentiment?.data,
    isLoadingContactSentiment,
    isFetchingContactSentiment,
    refetchContactSentiment
  };
};
